import { createContext, useContext } from 'react';
import type { MouseEvent, FocusEvent } from 'react';

export interface RichTextEditorContextValue {
  addImage: (image: File) => void;
  setPopoverOpen: (open: boolean) => void;
  onEditorFocus: (args: {
    event?: MouseEvent | FocusEvent<any>;
    force?: boolean;
    runAfterFocus?: () => void;
    focusEditor?: boolean;
  }) => void;
  disabled: boolean;
}

export const RichTextEditorContext = createContext<RichTextEditorContextValue>({
  addImage: () => {},
  setPopoverOpen: () => {},
  onEditorFocus: () => {},
  disabled: false
});

export const useRTEContext = () => {
  return useContext(RichTextEditorContext);
};
